import React from "react";
import { formatPrice } from "../../../../../utilities/formatPrice";
import { formatFloatToInteger } from "../../../../../utilities/formatFloatToInteger";

const MetricCard = ({ title, value, label, change, currency = "€", isInteger = false }) => {
  const formattedValue = isInteger ? formatFloatToInteger(value) : formatPrice(value);
  const displayValue = isInteger ? formattedValue : `${currency} ${formattedValue}`;

  return (
    <div
      className="flex flex-column justify-content-between p-2"
      style={{ minHeight: "100px", minWidth: "238px" }}
    >
      <div className="mb-2">
        <h4
          className="m-0 text-sm font-medium"
          style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
        >
          {title}
        </h4>
      </div>
      <div className="mb-2">
        <span className="text-2xl font-bold" style={{ color: "var(--theme-text)" }}>
          {title === "Extracredit" ? `${formattedValue} ECR` : displayValue}
        </span>
      </div>
      {label && (
        <div className="text-sm text-600 mb-2">
          {label} {title === "Extracredit" ? "(1 ECR = 1,00€)" : ""}
        </div>
      )}
      {change && (
        <div
          className="text-sm"
          style={{
            color: change.startsWith("+")
              ? "var(--theme-primary)"
              : "var(--theme-text-muted, #5C5C5C)",
          }}
        >
          {change}
        </div>
      )}
    </div>
  );
};

export default React.memo(MetricCard);
